$(function() {

    $('.heroes .swiper-container').each(function(i){
        var slide_num = $(this).find('.swiper-slide').length;
        var loop = false;
        if(slide_num > 1){
            loop = true;
        }
        
        $(this).addClass('ts'+i);
        $('.ts'+i).swiper({
            effect: 'fade',
            slidesPerView: 1,
            spaceBetween: 30,
            loop: loop,
            autoplay: 6000,
            speed: 1600,
            autoplayDisableOnInteraction: false
        });
    });
   
});
